import { render, staticRenderFns } from "./AutocompleteGrade.vue?vue&type=template&id=4a9dfe3d&scoped=true&"
import script from "./AutocompleteGrade.vue?vue&type=script&lang=js&"
export * from "./AutocompleteGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dfe3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
